import { images } from './content'

export type ProjectImage = {
  src: string
  alt: string
}

/** Carousel #1 — moves right → left, right after the pain section. */
export const carouselOne: ProjectImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/9edbc2d8-9132-4a15-ad3c-ed577d443480.jpg',
    alt: 'Handmade cardboard robot with bottle-cap eyes standing on a kitchen table',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/f457dde1-b06e-4fb3-80d7-b66f1a878e1d.jpg',
    alt: 'Cardboard mechanical hand with straw joints moved by strings',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/e5e00422-123f-4826-91b6-3a748c56a327.jpg',
    alt: 'Homemade cardboard robotic arm gripping a wooden block',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/b2e1cb1c-bad2-4548-8f9c-e5f922bb0870.jpg',
    alt: 'Cardboard race car with bottle-cap wheels on a dining table',
  },
  { src: images.balloonCar, alt: 'Cardboard car powered by a green balloon' },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/c8f2c014-cc48-46a4-addd-c4e689763350.jpg',
    alt: 'Vehicle made from a plastic bottle and colorful bottle caps',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/c967b255-807e-464d-837f-df97b474a2b2.jpg',
    alt: 'Cardboard truck with cardboard wheels and a taped cargo box',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/573c6bde-1f67-4733-8966-424394d3772d.jpg',
    alt: 'Rubber-band launcher built from craft sticks and a plastic spoon',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/48cf802d-cc6e-46e0-a3c8-b50800f367ea.jpg',
    alt: 'Small catapult made of craft sticks and rubber bands',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/fc1dc115-ea63-4a8e-8992-7f926422d70d.jpg',
    alt: 'Simple pulley system made from a spool and string lifting a paper cup',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/58368e80-f0bc-49e7-ac2d-62ff5a4ce4c5.jpg',
    alt: 'Homemade cardboard crane lifting a wooden block with a paper-clip hook',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/52642b91-c61e-44da-9ce9-702b5d001f60.jpg',
    alt: 'Cardboard and craft-stick bridge tested with small toy cars',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/d3d5bca9-1e5a-4979-a075-5dc17efc2cd6.jpg',
    alt: 'Marble run built from cardboard tubes and ramps',
  },
  { src: images.bottleRobot, alt: 'Robot built from recycled plastic bottles and caps' },
  { src: images.cupRobot, alt: 'Paper cup robot with pipe cleaner arms' },
  { src: images.bottleRocket, alt: 'Rocket built from a plastic bottle and painted paper' },
]

/** Carousel #2 — moves left → right, before the result section. */
export const carouselTwo: ProjectImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/69091f3d-e151-42d1-915f-a449a2e9e0a7.jpg',
    alt: 'Balloon inflating on top of a bottle in a simple air-pressure experiment',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/f7a28ce7-158e-46b8-9d96-61d28e69a7d5.jpg',
    alt: 'Floating and sinking water experiment in a glass bowl',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/61d20900-ead9-4141-9b04-641501a3d21a.jpg',
    alt: 'Homemade mini volcano erupting with foam on a kitchen tray',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/9ec96533-b91b-46d3-b876-dc8363009dda.jpg',
    alt: 'Balance scale made from a ruler, string and paper cups',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/ca9bf492-9f4d-4216-be0e-861ea982e1d0.jpg',
    alt: 'Robot built from a tin can, boxes, bottle caps and wire',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/0634a8a0-926b-4285-acf0-2ee71b24b349.jpg',
    alt: 'Mechanical cardboard creature with moving paper legs',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/7045b7b9-cf2e-4ec0-82e5-c60e62be4768.jpg',
    alt: 'Wind-powered cardboard cart with a paper sail',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/dae953b2-cf5a-438e-90d3-2ead974e921f.jpg',
    alt: 'Tall tower built from rolled paper tubes on a dining table',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/212af9e0-4044-4c3f-b81a-bcdfa36576b7.jpg',
    alt: 'Lever made from a ruler and cardboard tube lifting bottle caps',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/69423f1b-b255-407a-bf54-1f4407a2ad55.jpg',
    alt: 'Small cardboard house with cut-out windows and marker details',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/072cffdb-4e03-4407-accf-d70d96e0707e.jpg',
    alt: 'Dome structure built from paper straws and clay joints',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/465d4c80-ce1d-4237-af15-cf2775a160f7.jpg',
    alt: 'Invention built from a plastic bottle, tubes and bottle caps',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/37bc06e4-f15d-4f4f-bf22-eaab1b9d0cea.jpg',
    alt: 'Homemade parachute made from a plastic bag and string',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/2fdd4840-9f9f-4091-ad8b-a621da11392b.jpg',
    alt: 'Child shaping a small clay animal beside a printed activity sheet',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/dbaf12ef-4a47-46e0-8f1d-ecefa2560cd1.jpg',
    alt: 'Child launching a folded paper airplane indoors',
  },
  { src: images.spiralCandle, alt: 'Boy watching a paper spiral spin above two candles' },
]
